import {
    MERCHANT_TRANS_SETTINGS_LIST_INITIATED,
    MERCHANT_TRANS_SETTINGS_INITIATED,
    MERCHANT_TRANS_SETTINGS_LOADED,
    MERCHANT_TRANS_SETTINGS_FAILED,
    MERCHANT_TRANS_SETTINGS_LIST_LOADED,
    MERCHANT_TRANS_SETTINGS_COUNT_INITIATED,
    MERCHANT_TRANS_SETTINGS_COUNT_LOADED,
    MERCHANT_TRANS_SETTINGS_COUNT_FAILED
  } from "../actions/MerchantTransSettingsAction";
  
  const initialState = {
    listdata: [],
    data: [],
    merchantCount : {
      active_count : 0,
      inactive_count : 0,
      pending_count : 0,
      total_count : 0,
    },
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
  };
  
  const MerchantReducer = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_TRANS_SETTINGS_LIST_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case MERCHANT_TRANS_SETTINGS_LIST_LOADED:
        return {
          ...state,
          loading: false,
          data : {},
          listdata: action.payload.data,
          pagination: action.payload.pagination,
        };
      case MERCHANT_TRANS_SETTINGS_INITIATED:
        return { ...state, loading: true, error: null};
      case MERCHANT_TRANS_SETTINGS_LOADED:
        const updatedObj = Object.fromEntries(
            Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
        );
        return { ...state, loading: false, data: updatedObj };
      case MERCHANT_TRANS_SETTINGS_COUNT_INITIATED:
          return { ...state};
      case MERCHANT_TRANS_SETTINGS_COUNT_LOADED:
          return { ...state, merchantCount: action.payload };
      case MERCHANT_TRANS_SETTINGS_COUNT_FAILED:
          return { ...state };
      case MERCHANT_TRANS_SETTINGS_FAILED:
          return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantReducer;